const host = "https://betiket.apjii.or.id";
// const host = "http://localhost:8000";
const api = "/api";

export const URL_WS = "wss://betiket.apjii.or.id/ws/notification/";
// export const URL_WS = "ws://localhost:8000/ws/notification/";

export const base = host;
export const baseurl = `${host}${api}`;
export const API_URL_login = `${baseurl}/master/token/`;
export const API_URL_refresh = `${baseurl}/master/token/refresh/`;

export const API_URL_agent = `${baseurl}/master/users/`;
export const API_URL_agentEmail = `${baseurl}/master/usersemail/`;
export const API_URL_loginByToken = `${baseurl}/master/users/loginbytoken/`;
export const API_URL_loginByKeycloakCode = `${baseurl}/master/users/loginbykeycloak/`;
export const API_URL_slaplan = `${baseurl}/master/slaplan/`;
export const API_URL_department = `${baseurl}/master/department/`;
export const API_URL_team = `${baseurl}/master/team/`;
export const API_URL_teamMember = `${baseurl}/master/teammember/`;
export const API_URL_group = `${baseurl}/master/groups/`;
export const API_URL_permission = `${baseurl}/master/permission/`;
export const API_URL_timezone = `${baseurl}/master/timezone/`;
export const API_URL_widget = `${baseurl}/master/widget/`;
export const API_URL_socialWidget = `${baseurl}/master/socialwidget/`;
export const API_URL_banList = `${baseurl}/master/banlist/`;
export const API_URL_emailSetting = `${baseurl}/master/emailsetting/`;
export const API_URL_queueService = `${baseurl}/master/queueservice/`;
export const API_URL_ticketPriority = `${baseurl}/ticket/ticketpriority/`;
export const API_URL_companysetting = `${baseurl}/master/companysetting/`;
export const API_URL_apiSetting = `${baseurl}/master/apisetting/`;
export const API_URL_systemLog = `${baseurl}/master/systemlogs/`;
export const API_URL_securitySetting = `${baseurl}/master/securitysetting/`;
export const API_URL_ticketSetting = `${baseurl}/ticket/ticketsetting/`;
export const API_URL_autoResponseSetting = `${baseurl}/master/autoresponsesetting/`;
export const API_URL_alertNoticeSetting = `${baseurl}/master/alertnoticesetting/`;
export const API_URL_ticketStatus = `${baseurl}/ticket/ticketstatus/`;
export const API_URL_helpTopic = `${baseurl}/master/helptopic/`;
export const API_URL_templateSet = `${baseurl}/master/templateset/`;
export const API_URL_templateType = `${baseurl}/master/templatetype/`;
export const API_URL_templates = `${baseurl}/master/templates/`;
export const API_URL_email = `${baseurl}/master/email/`;
export const API_URL_workflowClose = `${baseurl}/master/workflowclose/`;
export const API_URL_rating = `${baseurl}/master/rating/`;
export const API_URL_systemSetting = `${baseurl}/master/systemsetting/`;
export const API_URL_dateTimeFormat = `${baseurl}/master/datetimeformat/`;
export const API_URL_kbCategory = `${baseurl}/kb/kbcategory/`;
export const API_URL_kbArticle = `${baseurl}/kb/kbarticle/`;
export const API_URL_kbArticleshow = `${baseurl}/kb/kbarticle/show/`;
export const API_URL_kbPages = `${baseurl}/kb/kbpages/`;
export const API_URL_kbSetting = `${baseurl}/kb/kbsetting/`;
export const API_URL_cannedResponse = `${baseurl}/master/cannedresponse/`;
export const API_URL_organization = `${baseurl}/master/organization/`;
export const API_URL_kbArticleRelationship = `${baseurl}/kb/kbarticlerelationship/`;
export const API_URL_ticket = `${baseurl}/ticket/ticket/`;
export const API_URL_ticketPortal = `${baseurl}/ticket/ticket/portal/`;
export const API_URL_resendReplyTicket = `${baseurl}/ticket/resendreplyticket/`;
export const API_URL_ticketCollaborator = `${baseurl}/ticket/ticketcollaborator/`;
export const API_URL_ticketSource = `${baseurl}/ticket/ticketsource/`;
export const API_URL_updateBatchTicket = `${baseurl}/ticket/ticket/updatebatch/`;
export const API_URL_deleteBatchTicket = `${baseurl}/ticket/ticket/deletebatch/`;
export const API_URL_ticketCountDepartment = `${baseurl}/ticket/ticket/count/`;
export const API_URL_countTicketStatus = `${baseurl}/ticket/ticketstatus/count/`;
export const API_URL_ticketAgentCreate = `${baseurl}/ticket/ticket/ticketagentcreate/`;
export const API_URL_createThreadTicket = `${baseurl}/ticket/ticket/createthread/`;
export const API_URL_ticketCountin = `${baseurl}/ticket/ticket/countinbox/`;
export const API_URL_ticketDashboard = `${baseurl}/ticket/ticketdashboard/`;
export const API_URL_report = `${baseurl}/master/report`;
export const API_URL_notification = `${baseurl}/master/notification`;
export const API_URL_notificationUpdate = `${baseurl}/master/notificationupdate`;
export const API_URL_ticketCreateNonAuth = `${baseurl}/ticket/ticket/createnonauth/`;
export const API_URL_mergeTicket = `${baseurl}/ticket/ticket/mergeticket/`;
export const API_URL_logDelete = `${baseurl}/master/logs/delete/`;
export const API_URL_spamPotential = `${baseurl}/master/spampotential/`;
export const API_URL_notificationDelete = `${baseurl}/master/notification/deletenotificationread/`;
export const API_URL_forgotPassword = `${baseurl}/master/forgotpassword/`;
export const API_URL_resetPassword = `${baseurl}/master/resetpassword/`;
export const API_URL_periodicTask = `${baseurl}/master/periodictask/`;
